import { StringMap, TOptions } from 'i18next';
import { getI18n } from 'react-i18next';

const getTranslation =
  (namespace: string) =>
  (t: string, options?: string | TOptions<StringMap> | undefined) =>
    getI18n().t(`${namespace}:${t}`, options);

export { getTranslation };
